import ContentAutorulesRedux from './content_autorules_redux';

export default ContentAutorulesRedux;
